import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { C } from '../lib/theme';

export default function Paywall({ trialDaysLeft, userId }) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(null);
  const [error, setError] = useState('');

  const PLANS = [
    {
      id: 'mensual',
      priceId: 'price_1TdT1LAWU271FEzdIaAUd6RM',
      mode: 'subscription',
      billing: 'mensual',
      label: t('paywall.plan_monthly_label'),
      price: t('paywall.plan_monthly_price'),
      period: t('paywall.plan_monthly_period'),
      detail: t('paywall.plan_monthly_detail'),
      highlight: false,
    },
    {
      id: 'anual',
      priceId: 'price_1TgLwrAWU271FEzd8shx6QQd',
      mode: 'subscription',
      billing: 'anual',
      label: t('paywall.plan_annual_label'),
      price: t('paywall.plan_annual_price'),
      period: t('paywall.plan_annual_period'),
      detail: t('paywall.plan_annual_detail'),
      highlight: true,
    },
  ];

  const FEATURES = [
    t('paywall.feature_chat'),
    t('paywall.feature_planner'),
    t('paywall.feature_weight'),
    t('paywall.feature_exercise'),
    t('paywall.feature_recipes'),
  ];

  async function handleSelectPlan(plan) {
    setLoading(plan.id);
    setError('');
    try {
      const res = await fetch('/api/stripe/create-checkout', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          priceId: plan.priceId,
          mode: plan.mode,
          metadata: {
            type: 'freelance',
            billing: plan.billing,
            user_id: userId || '',
          },
        }),
      });
      const data = await res.json();
      if (data.url) {
        window.location.href = data.url;
      } else {
        setError(t('paywall.error_payment'));
      }
    } catch {
      setError(t('paywall.error_connection'));
    } finally {
      setLoading(null);
    }
  }

  return (
    <div style={{ maxWidth: 480, margin: '0 auto' }}>
      <div style={{
        background: `linear-gradient(135deg, ${C.sage}, #40916C)`,
        borderRadius: 16, padding: '1.4rem', color: '#fff', marginBottom: '1rem',
        textAlign: 'center',
      }}>
        <div style={{ fontSize: '2rem', marginBottom: '0.4rem' }}>🌿</div>
        <h2 style={{ margin: '0 0 0.4rem', fontFamily: 'Georgia, serif', fontSize: '1.3rem' }}>
          {trialDaysLeft > 0
            ? t('paywall.trial_left', { count: trialDaysLeft })
            : t('paywall.trial_ended')}
        </h2>
        <p style={{ margin: 0, fontSize: '0.85rem', opacity: 0.85 }}>
          {t('paywall.subtitle')}
        </p>
      </div>

      <div style={{ background: '#fff', borderRadius: 16, padding: '1.2rem', boxShadow: '0 2px 12px rgba(44,106,79,0.08)', marginBottom: '1rem' }}>
        <h3 style={{ margin: '0 0 0.8rem', color: C.carbon, fontFamily: 'Georgia, serif', fontSize: '1rem' }}>
          {t('paywall.includes_all')}
        </h3>
        {FEATURES.map(f => (
          <div key={f} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
            <span style={{ color: C.sage, fontSize: '0.9rem' }}>✓</span>
            <span style={{ fontSize: '0.88rem', color: C.carbon }}>{f}</span>
          </div>
        ))}
      </div>

      {PLANS.map(plan => (
        <div
          key={plan.id}
          style={{
            background: plan.highlight ? C.mintLt : '#fff',
            border: `2px solid ${plan.highlight ? C.sage : C.mint}`,
            borderRadius: 16, padding: '1.2rem', marginBottom: '0.8rem',
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div>
              <div style={{ fontWeight: 700, color: C.carbon, fontSize: '0.95rem' }}>
                {plan.label}
                {plan.highlight && (
                  <span style={{ marginLeft: '0.5rem', fontSize: '0.72rem', background: C.sage, color: '#fff', borderRadius: 10, padding: '0.1rem 0.5rem' }}>
                    {t('paywall.best_value')}
                  </span>
                )}
              </div>
              <div style={{ fontSize: '0.82rem', color: C.gray, marginTop: '0.2rem' }}>{plan.detail}</div>
            </div>
            <div style={{ textAlign: 'right' }}>
              <span style={{ fontFamily: 'Georgia, serif', fontSize: '1.5rem', fontWeight: 700, color: C.sage }}>{plan.price}</span>
              <span style={{ fontSize: '0.78rem', color: C.gray }}>{plan.period}</span>
            </div>
          </div>
          <button
            onClick={() => handleSelectPlan(plan)}
            disabled={loading === plan.id}
            style={{
              marginTop: '0.8rem', width: '100%', padding: '0.75rem', borderRadius: 8,
              background: plan.highlight ? C.sage : '#fff',
              color: plan.highlight ? '#fff' : C.sage,
              border: `1.5px solid ${C.sage}`,
              fontWeight: 700, fontSize: '0.9rem', cursor: 'pointer',
              opacity: loading === plan.id ? 0.6 : 1,
            }}
          >
            {loading === plan.id ? t('paywall.redirecting') : t('paywall.subscribe_btn')}
          </button>
        </div>
      ))}

      {error && (
        <p style={{ color: C.terra, fontSize: '0.85rem', textAlign: 'center', margin: '0 0 0.8rem' }}>{error}</p>
      )}

      <div style={{ textAlign: 'center', fontSize: '0.78rem', color: C.gray, padding: '0.8rem', lineHeight: 1.6 }}>
        {t('paywall.secure_payment')}
      </div>
    </div>
  );
}
